import { ReactNode, useId } from 'react';
import { IControlProps } from '@srm/ui/controls/types';
import { useHookFormController } from '@srm/ui/hooks/useHookFormController';
import './FormFieldView.scss';

type Props = IControlProps & { children: (value: unknown) => ReactNode };

/** View-представление в работающей форме: регистрация, актуальное значение и ошибки сохраняются. */
const FormFieldView = ({ children, ...props }: Props) => {
    const Controller = useHookFormController();
    const messageId = useId();
    return (
        <Controller
            {...props}
            render={({ field, fieldState }) => {
                const message = fieldState.error?.message;
                return (
                    <div
                        className="form-field-view"
                        ref={field.ref}
                        tabIndex={-1}
                        aria-invalid={fieldState.invalid || undefined}
                        aria-describedby={message ? messageId : undefined}
                    >
                        {children(field.value)}
                        {/* Ошибка объявляется при появлении: элемент с role="alert" монтируется заново (канон FormGroup). */}
                        <div
                            key={message ? 'error' : 'empty'}
                            className="form-field-view__message"
                            id={messageId}
                            role={message ? 'alert' : undefined}
                        >
                            {message}
                        </div>
                    </div>
                );
            }}
        />
    );
};

export default FormFieldView;
